import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";

import config from "../../config";

export const uploadFile = async (file, onUploadProgress, docname) => {
    // const fileExtension = file.name.split(".").pop();
    const formData = new FormData();
    formData.append("floor_plan", file);
    let docType = `Restaurant Object`;
    try {
        const response = await axios.put(
            `/resource/${docType}/${docname}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        console.log("Attachment field updated successfully:", response.data);
    } catch (error) {
        console.error("Error updating attachment field:", error);
    }

    // const {name, file_name, folder} = data.message;
    return {
        fileExtension: "png",
    };
};

export const uploadFileOnFileSystem = async (
    file,
    onUploadProgress,
    docname,
    doctype,
    fieldname,
    csrfToken
) => {
    // const fileExtension = file.name.split(".").pop();
    const formData = new FormData();
    let token = localStorage.getItem("accessToken");

    console.log(token);
    formData.append("file", file);
    formData.append("is_private", "1");
    formData.append("folder", "Home");
    formData.append("doctype", doctype);
    formData.append("docname", docname);
    formData.append("fieldname", fieldname);
    formData.append("optimize", "true");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    
    // Add CSRF token if provided
    if (csrfToken) {
        myHeaders.append("x-frappe-csrf-token", csrfToken);
    }

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
    };

    let backUrl = config.baseUrl;
    return fetch(backUrl + "/api/method/upload_file", requestOptions);
};

export const useCreateResource = () => {

    return useMutation(
        async ({
            file,
            name,
            onUploadProgress,
            docname,
            doctype,
            fieldname,
            csrfToken,
        }) => {
            let params = {
                doctype: doctype,
                name: docname,
            };
            const fileUploadResult = await uploadFileOnFileSystem(
                file,
                onUploadProgress,
                docname,
                doctype,
                fieldname,
                csrfToken
            );
            const { message } = await fileUploadResult.json();
            const { modified, file_url } = message;

            // we will update the value of the object only if we have an item.
            if (doctype === "Item") {
                setTimeout(async () => {
                    let doc = {
                        image: file_url,
                    };
                    await updateDoctype(doc, docname);
                }, 1000);
            }

            return message;

            // const {data} = await axios.post("/method/frappe.desk.form.load.get_docinfo", JSON.stringify(params)
            //     , {headers});
            // return data;
        }
    );
};

const updateDoctype = (formData, itemName) => {
    try {
        return axios.put(`resource/Item/` + itemName, formData);
    } catch (err) {
        throw new err();
    }
};

export const useRoomBackgroundResources = (room) => {
    return useQuery(
        ["GetRoomBackground", room?.name],
        async () => {
            const data = await getFileFromFrappe(room);
            return data;
        },
        {
            enabled: !!room,
        }
    );
};

const getFileFromFrappe = async (room) => {
    if (!room) return null;
    let token = localStorage.getItem("accessToken");

    let headers = {
        Authorization: `${token}`,
        "Access-Control-Allow-Credentials": true,
        "Content-Type": "application/json charset=utf-8",
        Accept: "application/json",
    };
    try {
        let params = {
            doctype: `Restaurant Object`,
            name: room.name,
        };
        const { data } = await axios.post(
            "/method/frappe.desk.form.load.get_docinfo",
            params,
            { headers }
        );
        return data;
    } catch (error) {
        // Handle any errors that occur during the request
        console.error("Error fetching file from Frappe API:", error);
        throw error;
    }
};

export const useGetRoomDocInfo = (room) => {
    let token = localStorage.getItem("accessToken");

    let headers = {
        Authorization: `${token}`,
        "Access-Control-Allow-Credentials": true,
        "Content-Type": "application/json charset=utf-8",
        Accept: "application/json",
    };

    return useQuery(
        ["GetRoomBackground", room?.name],
        async () => {
            let params = {
                doctype: `Restaurant Object`,
                name: room.name,
            };

            const { data } = await axios.post(
                "/method/frappe.desk.form.load.get_docinfo",
                params,
                { headers }
            );
            return data;
        },
        {
            enabled: !!room,
        }
    );
};
